module.exports = "/assets/035a83a67ef481e1a630a0ded0ece8df.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos-small/NZ.png
// module id = 2788
// module chunks = 0